import { render, staticRenderFns } from "./store-authorization.vue?vue&type=template&id=52f5bc4a&scoped=true&"
import script from "./store-authorization.vue?vue&type=script&lang=js&"
export * from "./store-authorization.vue?vue&type=script&lang=js&"
import style0 from "./store-authorization.vue?vue&type=style&index=0&id=52f5bc4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f5bc4a",
  null
  
)

export default component.exports